import { useEffect, useState } from 'react';

export type BodyTheme = 'light' | 'dark' | null;

const readBodyTheme = (): BodyTheme => {
  if (typeof document === 'undefined') return null;
  const value = document.body.getAttribute('data-theme');
  return value === 'light' || value === 'dark' ? value : null;
};

export const useBodyDataTheme = (): BodyTheme => {
  const [theme, setTheme] = useState<BodyTheme>(readBodyTheme);

  useEffect(() => {
    const update = () => setTheme(readBodyTheme());
    update();
    const observer = new MutationObserver(update);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });
    return () => observer.disconnect();
  }, []);

  return theme;
};
